import GoogleApplePayment from "./GoogleApplePayment";
export default GoogleApplePayment;
